import { EditorTabAlert } from './EditorTabAlert';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TabbedEditorErrorState({
  reset = () => {}
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    minBlockSize: "156px",
    backgroundColor: "fill-surface-default",
    borderBlockEndWidth: "100",
    borderBlockEndStyle: "solid",
    borderBlockEndColor: "border-core-subtle",
    children: [/*#__PURE__*/_jsx(View, {
      blockSize: "49px",
      inlineSize: "100%",
      flexShrink: 0,
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-subtle"
    }), /*#__PURE__*/_jsx(View, {
      padding: "500",
      children: /*#__PURE__*/_jsx(EditorTabAlert, {
        reset: reset
      })
    })]
  });
}
TabbedEditorErrorState.displayName = 'TabbedEditorErrorState';